import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  IconButton,
  Chip,
  Stack
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  LocationOn,
  AttachMoney
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DEFAULT_IMAGE } from '../../constants';

const AdvertisementCard = ({ item, onEdit, onDelete }) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardMedia
        component="img"
        height="200"
        image={item.images?.[0]?.fileName || DEFAULT_IMAGE}
        alt={item.listingTitle}
        onError={(e) => {
          e.target.src = DEFAULT_IMAGE;
        }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h6" component="h2" noWrap>
          {item.listingTitle}
        </Typography>
        
        <Stack direction="row" spacing={1} mb={2}>
          <Chip 
            icon={<AttachMoney />} 
            label={`${item.monthlyRent} TL`}
            size="small"
          />
          <Chip 
            icon={<LocationOn />} 
            label={`${item.districtName}, ${item.cityName}`}
            size="small"
          />
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          mb: 2
        }}>
          {item.description}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <IconButton 
            size="small" 
            onClick={onEdit}
            color="primary"
          >
            <EditIcon />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={onDelete}
            color="error"
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AdvertisementCard; 